import { useMenuFrvtUpdate } from 'api/common/search-fetch'
import { Heading, IconButton, ImageSlider, InfoList, Line, ListTitle, StateDot, Tag } from 'components'
import useModal from 'hook/useModal'
import { entries, mapValues } from 'lodash'
import { useEffect, useState } from 'react'
import { useRecoilValue } from 'recoil'
import { userInfoState } from 'store/atom/user-state-atom'
import { getMessage } from 'utils/message-util'

// css
import 'assets/style/common.scss'
import { combineImages } from 'utils/image-mark'

const ItemList = ({ list = [] }) => {
  return (
    <ul>
      {list.map((item, index) => {
        const irdsRto = Math.round(item.irdsRto || 0)
        const tags = [
          { text: item.gdNo, color: 'gray' },
          { text: item.oriplc, color: 'gray' },
          {
            text: irdsRto
              ? `${item.irdsRto > 0 ? '▲' : '▼'} ${(item.irdsRto > 0 ? irdsRto : irdsRto * -1) + ' %'}`
              : null,
            color: item.irdsRto === null ? 'black-line' : item.irdsRto > 0 ? 'red' : 'blue',
          },
        ]
        return (
          <li className="mt8 border-radius-2 p12 bg-f" key={`recip3_${index}`}>
            <Tag data={tags.filter(({ text }) => text)} />
            {/* flex-between  */}
            <div className="mt8">
              <StateDot color={item.gdUsSttsCd === '0' ? 'success' : item.gdUsSttsCd === '2' ? 'warning' : 'error'} />
              <span className="ml-4 f-14 c-3 f-500">{item.gdBd}</span>
            </div>
            <InfoList
              level="2"
              className="mt12 gap-30"
              dataAlign="right"
              titleWidth={'45px'}
              data={[
                { id: 1, title: '1인량', data: (item.igrQty || 0).toLocaleString() + ' g' },
                { id: 2, title: '1인원가', data: (item.trfUnprc || 0).toLocaleString() + ' 원' },
              ]}
            />
            <InfoList
              level="4"
              className="mt4"
              dataAlign="left"
              titleWidth={'45px'}
              spanMargin={'6px'}
              data={[
                { id: 1, title: '해동', data: item.dfrtNeedYn },
                { id: 2, title: '소독', data: item.dsiftNeedYn },
                { id: 3, title: '중심온도', data: item.cntrTptCnfrmNeedYn },
                { id: 4, title: '원산지', data: item.oriplcYn },
              ]}
            />
          </li>
        )
      })}
    </ul>
  )
}

const NutrientList = ({ title, value, unit = 'g' }) => (
  <li>
    <span className="label">{title}</span>
    <span className="data">
      <b>{typeof value !== 'number' ? '-' : value}</b> {unit}
    </span>
  </li>
)

export default function MenuRecipStd({ dataList = [], imgList = [], menuInfo = {} }) {
  const userInfo = useRecoilValue(userInfoState)
  const { alertModal } = useModal()
  const [isFvrt, setIsFvrt] = useState(false)
  const [totalNutt, setTotalNutt] = useState({})
  const ulstyle = { gridTemplateColumns: '1fr 1fr 1fr 1fr 1fr', boxShadow: 'none' }
  const [imgUrl, setImgUrl] = useState('')

  const menuFrvtUpdate = useMenuFrvtUpdate({
    successHandler: (res, data) => {
      if (data.useYn === 'Y') {
        alertModal(res === 1 ? getMessage('common_msg_006') : getMessage('common_msg_007'))
        setIsFvrt(true)
      } else {
        setIsFvrt(false)
      }
    },
    errorHandler: () => {},
  })

  useEffect(() => {
    if (dataList.length > 0) {
      let result = {}
      dataList.map((item) => {
        for (const key in item) {
          if ('caloQty,carbohydrateQty,protQty,fatQty,natriumQty'.includes(key)) {
            result[key] = (result[key] || 0) + item[key]
          }
        }
        return null
      })
      const roundedSums = mapValues(result, (sum) => Math.round(sum * 100) / 100)
      setTotalNutt(roundedSums)
      setIsFvrt(menuInfo.bookmarkYn === 'Y')
    }
  }, [dataList])

  useEffect(() => {
    const lists = imgList || []

    if (!Array.isArray(lists) || lists.length === 0) return

    let cancelled = false

    const run = async () => {
      const stdImage = lists.find((item) => item.menuSeq === 0 && item.uriType === '0')

      let finalImgUrl = ''
      const originUrl = process.env.REACT_APP_PRODUCT_MENU_IMAGE_URL + '/' + stdImage.imgUrl + '?RS=384x288'

      if (stdImage?.aiImgYn === 'Y') {
        try {
          finalImgUrl = await combineImages(originUrl, 'Y', true)
        } catch (e) {
          finalImgUrl = originUrl
        }
      } else {
        finalImgUrl = originUrl
      }

      if (!cancelled) {
        setImgUrl(finalImgUrl)
      }
    }

    run()

    return () => {
      cancelled = true
      setImgUrl('')
    }
  }, [imgList])

  return (
    <>
      <div>
        <div className="fixed-star-btn" style={{ zIndex: 5200, marginBottom: '60px' }}>
          <IconButton
            text="즐겨찾기"
            size="48"
            className={`star bookmark ${isFvrt && 'active'}`}
            onClick={() => {
              menuFrvtUpdate.mutate({
                coId: userInfo.coId,
                regSteId: userInfo.siteId,
                sessUserId: userInfo.userId,
                userId: userInfo.userId,
                myMenuDvsnCd: '1',
                orgtSteId: userInfo.siteId,
                useYn: !isFvrt ? 'Y' : 'N',
                menuId: menuInfo?.menuId,
                menuSeq: '0',
                myMenuDvsnCd: '1',
              })
            }}
          />
        </div>

        <section className="wrapper mt24">
          <Tag data={[{ text: dataList[0]?.siteNm, color: 'green' }]} />
          <div className="mt4 mb18 flex-between">
            <Heading className="f-20 f-normal">
              [{dataList[0]?.menuId}]{dataList[0]?.menuNm}
            </Heading>
            {/* <Button text="변경" color="outline" className="small" /> */}
          </div>
        </section>

        <ImageSlider
          addButton="false"
          addButtonClick={() => {}}
          data={[
            {
              src: imgUrl,
              className: 'w100p',
              cTTL: true,
              watermarkYn: true,
            },
          ]}
        />
        <section className="wrapper pb24 mt16">
          <ul className="icon-info-list">
            <li>
              <span className="label icon-info-1">점포가</span>
              <span className="data">
                <b>{(dataList[0]?.totTrfUnprc || 0).toLocaleString()}</b> 원
              </span>
            </li>
          </ul>
        </section>

        <section className="wrapper-gray pt24 pb32">
          <ListTitle title="식재정보" count={dataList.length || 0} className="border-none mb8" />
          <Heading level="4" className="mt8 f-noto f-14 c-3 f-normal" text="주재료/재료/고명" />
          <ItemList list={dataList?.filter((item) => ['A', 'B', 'H'].indexOf(item.igrMtrlCd) > -1)} />

          <Heading level="4" className="f-noto mt16 f-14 c-3 f-normal" text="주양념/양념" />
          <ItemList list={dataList?.filter((item) => ['C', 'D', 'F'].indexOf(item.igrMtrlCd) > -1)} />

          <Heading level="4" className="f-noto mt16 f-14 c-3 f-normal" text="식수/육수" />
          <ItemList list={dataList?.filter((item) => ['E', 'G'].indexOf(item.igrMtrlCd) > -1)} />
        </section>
        <section className="wrapper mt24">
          <Heading level="2" text="영양소 정보" className="f-16" />
          <ul className="nutrient-list mt8" style={ulstyle}>
            <NutrientList title="열량" value={totalNutt.caloQty} unit="kcal" />
            <NutrientList title="탄수화물" value={totalNutt.carbohydrateQty} />
            <NutrientList title="단백질" value={totalNutt.protQty} />
            <NutrientList title="지방" value={totalNutt.fatQty} />
            <NutrientList title="나트륨" value={totalNutt.natriumQty} unit="mg" />
          </ul>
        </section>
        <section className="wrapper mt32">
          <ListTitle title="상세 정보" className="mb8" />
          <Line size="1" color="black" />
          <InfoList
            className="mt12"
            titleWidth="70px"
            data={[
              { id: 1, title: '메뉴분류', data: `${menuInfo.ccMenuClsNm} > ${menuInfo.ssMenuClsNm}` },
              { id: 2, title: '대표메뉴', data: menuInfo.rprsMenuNm },
              { id: 3, title: '메뉴컨셉', data: menuInfo.menuCctNm },
              { id: 4, title: '메뉴스타일', data: menuInfo.menuStyleNm },
              { id: 5, title: '메뉴색', data: menuInfo.menuColrNm }, //레드컬러 아이콘 추가해야함
              { id: 6, title: '조리상태', data: menuInfo.cokSttsNm },
              { id: 7, title: '조리법', data: menuInfo.menuRcipNm },
              { id: 8, title: '주재료', data: menuInfo.arrIgrGrpClsNm || '-' },
              { id: 9, title: '주양념', data: menuInfo.mssgClsNm },
              { id: 10, title: '추천시기', data: menuInfo.recmTimNm || '-' },
              { id: 11, title: '추천소스', data: menuInfo.recmSoucMenuNm || '-' },
              { id: 12, title: '고객경로', data: menuInfo.custRoutNm || '-' },
              { id: 13, title: '등록일자', data: menuInfo.menuCretYmd },
            ]}
          />
        </section>
      </div>
    </>
  )
}
